var app = angular.module("leonardo");

var TaskMoreAppDialog = function($scope, ngDialog) {
  $scope.url = $scope.ngDialogData.url;
};

app.controller('TaskMoreAppDialog', ['$scope', 'ngDialog', TaskMoreAppDialog]);
